(function() { window.GUID_4390c6fc_5b5a_40c0_b814_b1643c7f3575 = { getGuid: function() { return "4390c6fc-5b5a-40c0-b814-b1643c7f3575"; } }; })();
class ScoreSheetFinder {
    constructor() {
        this.debug = false;
        this.selectable = true;
        this.fieldNameToColumnTitleMap = {
            isForSingles: "IsForSingles",
            isForEveryone: "IsForEveryone",
            hasBreakLabel: "HasBreakLabels",
            hasWinBoxes: "HasWinBoxes",
            hasHandicap: "HasHandicap",
            hasFlawlessBox: "HasFlawlessBox",
            hasFlawlessList: "HasFlawlessList",
            hasMoney: "HasMoney",
            hasRoundPointModifier: "HasRoundPointModifier",
            hasTotalScoreModifier: "HasTotalScoreModifier",
            has8Ball: "Has8Ball",
            has9Ball: "Has9Ball",
            has10Ball: "Has10Ball",
            hasDoubles: "HasDoubles",
            hasInnings: "HasInnings",
            hasSpecial: "HasSpecial",
            hasPlayerRepeater: "HasPlayerRepeater",
            isVertical: "IsVertical",
            hasTotalsForVertical: "HasTotalsForVertical",
            gameRowsAreDynamic: "GameRowsAreDynamic",
        };
        this.init();
    }
    init() {
        this.data = {};
        this.popup = new CompuSport.Controls.Popup();
        this.callback = () => { };
        this.compareTokenInput = undefined;
        this.selectable = true;
        ScoreSheetFinderStore.instance.reset();
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new ScoreSheetFinder();
        }
        return this._instance;
    }
    /**
     * State of the finder. The store owns the filters and computes the results; the
     * finder only reads the state, writes to it and renders what the store returns.
     */
    static get store() {
        return ScoreSheetFinderStore.instance;
    }
    static get filters() {
        return ScoreSheetFinderStore.instance.filters;
    }
    static get eventAutocomplete() {
        var _a;
        return (_a = $("#scoreSheetFinderEventsAutocomplete").data()) === null || _a === void 0 ? void 0 : _a.context;
    }
    static get opponentTypePicker() {
        return $("#scoreSheetFinderOpponentTypePicker");
    }
    static get playersPicker() {
        return $("#scoreSheetFinderPlayersPerTeamPicker");
    }
    static get playersPicker2() {
        return $("#scoreSheetFinderPlayersPerTeamPicker2");
    }
    static get gamesPicker() {
        return $("#scoreSheetFinderGamesPerMatchPicker");
    }
    static get gamesPicker2() {
        return $("#scoreSheetFinderGamesPerMatchPicker2");
    }
    static get roundsPicker() {
        return $("#scoreSheetFinderRoundsPicker");
    }
    static get roundsPicker2() {
        return $("#scoreSheetFinderRoundsPicker2");
    }
    static get rotationsButton() {
        return $("#scoreSheetFinderRotationsPicker");
    }
    static get advancedFiltersButton() {
        return $("#scoreSheetFinderAdvancedFilters");
    }
    static get formatPicker() {
        return $("#scoreSheetFinderFormatPicker");
    }
    static get raceToChip() {
        return $("#scoreSheetFinderRaceToChip");
    }
    static get raceToSwitch() {
        return $("#scoreSheetFinderRaceToSwitch");
    }
    static get myScoreSheetsChip() {
        return $("#scoreSheetFinderMyScoreSheetsChip");
    }
    static get myScoreSheetsSwitch() {
        return $("#scoreSheetFinderMyScoreSheetsSwitch");
    }
    static get advancedFiltersDrawer() {
        return $("#scoreSheetFinderAdvancedFiltersDrawer");
    }
    static get roundRotationsDrawer() {
        return $("#scoreSheetFinderRotationsDrawer");
    }
    static get roundRotationsChip() {
        return $("#scoreSheetFinderRoundRotationsChip");
    }
    static get eventChip() {
        return $("#scoreSheetFinderEventChip");
    }
    /** Chips of the advanced filters, one per filter rendered by the server. */
    static get advancedFilterChips() {
        return $(".scoreSheetFinderAdvancedFilterChip");
    }
    /**
     * Search by id control. It is created once the content of the finder is loaded,
     * so it is held by the instance instead of being looked up in the DOM.
     */
    static get compareMultiSelect() {
        return ScoreSheetFinder.instance.compareTokenInput;
    }
    static onGridCompareMultiSelectChange(ids) {
        try {
            const isEmpty = !(ids === null || ids === void 0 ? void 0 : ids.length);
            ScoreSheetFinder.updateFilters({
                payload: {
                    name: "ids",
                    value: isEmpty ? undefined : ids,
                },
            });
        }
        catch (error) {
            console.error("Error while changing grid compare multi select", error);
        }
    }
    /**
     * Whether a score sheet can be picked. The results only offer a preview when the
     * finder was opened with nothing to hand the chosen score sheet back to.
     */
    static get selectable() {
        return ScoreSheetFinder.instance.selectable;
    }
    /**
     * Opens the finder to look through the score sheets, without picking one. There is
     * no caller waiting for a score sheet, so the results drop their select action.
     */
    static browse() {
        const { instance } = ScoreSheetFinder;
        instance.selectable = false;
        ScoreSheetFinder.show(() => { });
    }
    static show(callback, flowBlockId) {
        if (ScoreSheetFinder.instance.debug) {
            console.log("Showing score sheet finder");
        }
        const { instance } = this;
        instance.callback = callback;
        instance.popup.GetAndShow({
            PopupId: "ScoreSheetFinderPopup",
            Title: CS.CSRess({
                english: "Find a score sheet",
                french: "Trouver une feuille de pointage",
                spanish: "Encontrar una hoja de puntuación",
            }),
            Data: {
                flowBlockId: flowBlockId,
            },
            Url: CSParameters.RUrl + "ScoreSheetFinder/Show/",
            AjaxCallType: CompuSport.Ajax.AjaxCallType.GET,
        });
        instance.popup.OnContentLoaded = () => {
            // Prevent scrolling of body
            //   $("body").css("overflow", "hidden");
            ScoreSheetFinder.setInitialResults();
            ScoreSheetFinder.bindResultsEvents();
            ScoreSheetFinder.bindToolbarEvents();
            ScoreSheetFinder.bindDrawersEvents();
            ScoreSheetFinder.setUpCompareMultiSelect();
            ScoreSheetFinder.setInitialFilters();
            ScoreSheetFinder.setDrawersContent();
            let $scoreSheetFinderEventId = $("#ScoreSheetFinderEventId");
            const $scoreSheetFinderEventIdTextBox = $("#ScoreSheetFinderEventIdTextBox");
            if ($scoreSheetFinderEventIdTextBox.length) {
                // The search field of the events autocomplete is styled by the finder,
                // so the classes it carries from elsewhere are dropped.
                $scoreSheetFinderEventIdTextBox.addClass("ssf-textbox");
                $scoreSheetFinderEventIdTextBox.removeClass("AutoCompleteTextBox CSTextBox");
            }
            instance.autocomplete = $scoreSheetFinderEventId.data("context");
            CS.on("change keyup", "#ScoreSheetFinderEventIdTextBox", function (e, autocompletetest) {
                if (instance.autocomplete.$TextBox.val() == "") {
                    instance.autocomplete.ClearValue();
                }
            });
            $scoreSheetFinderEventId.on("change", function () {
                var _a;
                const eventId = $scoreSheetFinderEventId.val();
                const eventName = instance.autocomplete.SelectedValue();
                const compareMultiSelect = ScoreSheetFinder.compareMultiSelect;
                if (eventId) {
                    ScoreSheetFinder.store.resetFilters();
                    ScoreSheetFinder.clearAllChips();
                    if (compareMultiSelect) {
                        compareMultiSelect.clear();
                    }
                    ScoreSheetFinder.updateFilters({
                        payload: {
                            name: "eventId",
                            value: eventId,
                        },
                    });
                    const eventChip = ScoreSheetFinder.eventChip;
                    if (eventChip.length) {
                        ScoreSheetFinderControls.setChipSelected(eventChip, true);
                        ScoreSheetFinderControls.setChipLabel(eventChip, eventName);
                        (_a = ScoreSheetFinder.instance.autocomplete) === null || _a === void 0 ? void 0 : _a.ClearValue();
                    }
                }
                else {
                    ScoreSheetFinder.filters.rotations.value = undefined;
                }
            });
        };
        instance.popup.OnClosed = () => {
            $("body").css("overflow", "");
            ScoreSheetFinder.reset();
        };
    }
    static reset() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Resetting score sheet finder");
            }
            const { instance } = ScoreSheetFinder;
            instance.init();
        }
        catch (error) {
            console.error("Error while resetting score sheet finder", error);
        }
    }
    /**
     * Seeds the store with the results rendered by the server. From that point on the
     * store is the only holder of the full result set, and the list and the cards only
     * ever draw what it computes.
     */
    static setInitialResults() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Setting initial results");
            }
            ScoreSheetFinder.store.setResults(ScoreSheetFinderResults.initialResults);
        }
        catch (error) {
            console.error("Error while setting initial results", error);
        }
    }
    /** Wires the results to the state, and draws the shell they are drawn into. */
    static bindResultsEvents() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Binding results events");
            }
            ScoreSheetFinderResults.setUp();
            ScoreSheetFinderResults.bindEvents();
        }
        catch (error) {
            console.error("Error while binding results events", error);
        }
    }
    /**
     * Wires the controls of the toolbar to their handlers.
     *
     * The content of the finder is rebuilt every time the popup opens, so the handlers
     * are attached to the controls that were just rendered and go away with them.
     */
    static bindToolbarEvents() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Binding toolbar events");
            }
            ScoreSheetFinder.opponentTypePicker.on("change", function () {
                ScoreSheetFinder.onOpponentTypePickerChange();
            });
            ScoreSheetFinder.playersPicker.on("change", function () {
                ScoreSheetFinder.onPlayersPerTeamPickerChange();
            });
            ScoreSheetFinder.gamesPicker.on("change", function () {
                ScoreSheetFinder.onGamesPerMatchPickerChange();
            });
            ScoreSheetFinder.roundsPicker.on("change", function () {
                ScoreSheetFinder.onRoundsPickerChange();
            });
            ScoreSheetFinder.formatPicker.on("change", function () {
                ScoreSheetFinder.onFormatPickerChange();
            });
            ScoreSheetFinder.advancedFiltersButton.on("click", function () {
                ScoreSheetFinder.toggleAdvancedFiltersDrawer();
            });
            ScoreSheetFinder.rotationsButton.on("click", function () {
                ScoreSheetFinder.toggleRotationsDrawer();
            });
            $("#scoreSheetFinderResetFilters").on("click", function () {
                ScoreSheetFinder.resetFilters();
            });
            ScoreSheetFinder.bindChip(ScoreSheetFinder.raceToChip, ScoreSheetFinder.onRaceToChipSelect);
            ScoreSheetFinder.bindChip(ScoreSheetFinder.myScoreSheetsChip, ScoreSheetFinder.onMyScoreSheetsChipSelect);
            ScoreSheetFinder.bindChip(ScoreSheetFinder.eventChip, ScoreSheetFinder.onEventChipSelect);
            ScoreSheetFinder.bindChip(ScoreSheetFinder.roundRotationsChip, ScoreSheetFinder.onRoundRotationsChipSelect);
            ScoreSheetFinder.bindChip(ScoreSheetFinder.advancedFilterChips, ScoreSheetFinder.onAdvancedFilterChipSelect);
        }
        catch (error) {
            console.error("Error while binding toolbar events", error);
        }
    }
    /** A chip behaves like a button: it answers to a click and to the keyboard. */
    static bindChip($chip, handler) {
        if (!($chip === null || $chip === void 0 ? void 0 : $chip.length)) {
            return;
        }
        $chip.on("click", handler);
        $chip.on("keydown", function (e) {
            if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
                e.preventDefault();
                handler(e);
            }
        });
    }
    /**
     * Wires both drawers. Every handler is attached to the drawer itself, once, and
     * covers the content that is injected into it afterwards. The drawer used to
     * rebind its overlay every single time it was opened.
     */
    static bindDrawersEvents() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Binding drawers events");
            }
            [
                ScoreSheetFinder.advancedFiltersDrawer,
                ScoreSheetFinder.roundRotationsDrawer,
            ].forEach(function ($drawer) {
                if (!($drawer === null || $drawer === void 0 ? void 0 : $drawer.length)) {
                    return;
                }
                // Closing happens from the overlay, from the X and from Confirm, which
                // only ever closes the drawer: the filters are already applied.
                $drawer.on("click", ".ssf-drawer__overlay, [data-ssf-drawer-close]", function () {
                    ScoreSheetFinderControls.toggleDrawer($drawer, false);
                });
            });
            ScoreSheetFinder.advancedFiltersDrawer.on("change", ".scoreSheetFinderAdvancedFilterSwitch", function (e) {
                ScoreSheetFinder.toggleAdvancedFilter(e);
            });
            const $rotationsDrawer = ScoreSheetFinder.roundRotationsDrawer;
            $rotationsDrawer.on("change", "#scoreSheetFinderPlayersPerTeamPicker2", function () {
                ScoreSheetFinder.onPlayersPerTeamPickerChange2();
            });
            $rotationsDrawer.on("change", "#scoreSheetFinderGamesPerMatchPicker2", function () {
                ScoreSheetFinder.onGamesPerMatchPickerChange2();
            });
            $rotationsDrawer.on("change", "#scoreSheetFinderRoundsPicker2", function () {
                ScoreSheetFinder.onRoundsPickerChange2();
            });
            $rotationsDrawer.on("change", ".scoreSheetFinderRotationRoundSwitch", function () {
                ScoreSheetFinder.toggleRoundRotations();
            });
            $rotationsDrawer.on("change", ".scoreSheetFinderRotationHomePlayer", function (e) {
                ScoreSheetFinder.onRoundRotationHomePlayerChange(e);
            });
            $rotationsDrawer.on("change", ".scoreSheetFinderRotationAwayPlayer", function (e) {
                ScoreSheetFinder.onRoundRotationAwayPlayerChange(e);
            });
        }
        catch (error) {
            console.error("Error while binding drawers events", error);
        }
    }
    /**
     * Creates the search by id control and feeds it with the ids of the initial result
     * set, which is exactly what the widget it replaces was bound to.
     */
    static setUpCompareMultiSelect() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Setting up the search by id control");
            }
            const $root = $("#scoreSheetFinderCompareMultiSelect");
            if (!$root.length) {
                throw new Error("Search by id control is not defined");
            }
            const tokenInput = new ScoreSheetFinderTokenInput($root, function (ids) {
                ScoreSheetFinder.onGridCompareMultiSelectChange(ids);
            });
            tokenInput.setSource(ScoreSheetFinder.store.results.map(function (result) {
                return result.Id;
            }));
            ScoreSheetFinder.instance.compareTokenInput = tokenInput;
        }
        catch (error) {
            console.error("Error while setting up the search by id control", error);
        }
    }
    static setDrawersContent() {
        var _a, _b, _c;
        if (ScoreSheetFinder.instance.debug) {
            console.log("Setting drawers content");
        }
        const { filters } = ScoreSheetFinder.store;
        ScoreSheetFinderApi.getDrawersContent({
            players: (_a = filters.NbPlayers.value) !== null && _a !== void 0 ? _a : null,
            games: (_b = filters.NbGames.value) !== null && _b !== void 0 ? _b : null,
            rounds: (_c = filters.NbRounds.value) !== null && _c !== void 0 ? _c : null,
        }, ({ advancedFiltersDrawerContent, rotationsDrawerContent }) => {
            var _a, _b, _c;
            try {
                $("#scoreSheetFinderAdvancedFiltersDrawer-content").html(advancedFiltersDrawerContent);
                $("#scoreSheetFinderRotationsDrawer-content").html(rotationsDrawerContent);
                const games = (_a = filters.NbGames.value) !== null && _a !== void 0 ? _a : 0;
                const rounds = (_b = filters.NbRounds.value) !== null && _b !== void 0 ? _b : 0;
                const players = (_c = filters.NbPlayers.value) !== null && _c !== void 0 ? _c : 0;
                const $drawer = ScoreSheetFinder.roundRotationsDrawer;
                const $drawerContent = $drawer.find(".drawer-content__content");
                const $drawerEmptyStateContent = $drawer.find(".drawer-content__empty-state-content");
                if (games == 0 || rounds == 0 || players == 0) {
                    $drawerContent.addClass("hiddenforced");
                    $drawerEmptyStateContent.removeClass("hiddenforced");
                }
                else {
                    $drawerContent.removeClass("hiddenforced");
                    $drawerEmptyStateContent.addClass("hiddenforced");
                }
                // The controls of the drawers are only there once their content is
                // loaded, so their state is applied again now that they exist.
                ScoreSheetFinder.updateFiltersUI();
            }
            catch (error) {
                console.error("Error while setting drawers content", error);
            }
        });
    }
    static generateThumbnail(id, callback) {
        if (ScoreSheetFinder.instance.debug) {
            console.log(`Generating thumbnail for score sheet ${id}`);
        }
        ScoreSheet.generateThumbnail({
            scoreSheetId: id,
            callback: callback,
        });
    }
    static previewScoreSheet(id, callback) {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log(`Previewing score sheet ${id}`);
            }
            ScoreSheetFinderResults.selectRow(id);
            const popup = new CompuSport.Controls.Popup();
            var data = {
                encounterTypeId: id,
            };
            popup.GetAndShow({
                PopupId: "PreviewScoreSheetPopup",
                Data: data,
                Url: CSParameters.RUrl +
                    "Scores/PreviewPopup/" +
                    CSParameters.SportEventId,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET,
            });
            popup.OnContentLoaded = () => {
                if (callback) {
                    callback === null || callback === void 0 ? void 0 : callback.call(this, popup);
                }
            };
        }
        catch (error) {
            console.error("Error while previewing score sheet", error);
        }
    }
    static selectScoreSheet(id) {
        if (ScoreSheetFinder.instance.debug) {
            console.log(`Selecting score sheet ${id}`);
        }
        const { instance } = this;
        instance.popup.Close();
        instance.callback.call(instance, id);
    }
    /** Opens or closes a drawer. Omitting the state toggles it. */
    static toggleDrawer(id, state) {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log(`Toggling drawer ${id}`);
            }
            ScoreSheetFinderControls.toggleDrawer($(`#${id}`), state);
        }
        catch (e) {
            console.error("Error while toggling drawer", e);
        }
    }
    static toggleAdvancedFiltersDrawer() {
        ScoreSheetFinder.toggleDrawer("scoreSheetFinderAdvancedFiltersDrawer");
    }
    static toggleRotationsDrawer() {
        ScoreSheetFinder.toggleDrawer("scoreSheetFinderRotationsDrawer");
    }
    static onOpponentTypePickerChange() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing opponent type");
            }
            const opponentType = ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.opponentTypePicker);
            const items = [
                { name: "opponentType", value: opponentType },
            ];
            switch (opponentType) {
                case "teams":
                    items.push({ name: "NbPlayers", value: "" });
                    items.push({ name: "HasDoubles", value: undefined });
                    break;
                case "singles":
                    items.push({ name: "NbPlayers", value: 1 });
                    items.push({ name: "HasDoubles", value: undefined });
                    break;
                case "doubles":
                    items.push({ name: "NbPlayers", value: "" });
                    items.push({ name: "HasDoubles", value: true });
                    break;
                default:
                    items.push({ name: "NbPlayers", value: "" });
                    items.push({ name: "HasDoubles", value: undefined });
                    break;
            }
            ScoreSheetFinder.updateFilters({
                payload: items,
            });
        }
        catch (error) {
            console.error("Error while changing opponent type", error);
        }
    }
    static onPlayersPerTeamPickerChange() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing players per team");
            }
            const players = ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.playersPicker);
            ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.playersPicker2, players);
            ScoreSheetFinder.updateFilters({
                payload: { name: "NbPlayers", value: players },
            });
        }
        catch (error) {
            console.error("Error while changing players per team", error);
        }
    }
    static onPlayersPerTeamPickerChange2() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing players per team 2");
            }
            ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.playersPicker, ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.playersPicker2));
            ScoreSheetFinder.onPlayersPerTeamPickerChange();
        }
        catch (error) {
            console.error("Error while changing players per team 2", error);
        }
    }
    static onGamesPerMatchPickerChange() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing games per match");
            }
            const games = ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.gamesPicker);
            ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.gamesPicker2, games);
            ScoreSheetFinder.updateFilters({
                payload: { name: "NbGames", value: games },
            });
        }
        catch (error) {
            console.error("Error while changing games per match", error);
        }
    }
    static onGamesPerMatchPickerChange2() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing games per match 2");
            }
            ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.gamesPicker, ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.gamesPicker2));
            ScoreSheetFinder.onGamesPerMatchPickerChange();
        }
        catch (error) {
            console.error("Error while changing games per match 2", error);
        }
    }
    static onRoundsPickerChange() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing rounds");
            }
            const rounds = ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.roundsPicker);
            ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.roundsPicker2, rounds);
            ScoreSheetFinder.updateFilters({
                payload: { name: "NbRounds", value: rounds },
            });
        }
        catch (error) {
            console.error("Error while changing rounds", error);
        }
    }
    static onRoundsPickerChange2() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing rounds 2");
            }
            ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.roundsPicker, ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.roundsPicker2));
            ScoreSheetFinder.onRoundsPickerChange();
        }
        catch (error) {
            console.error("Error while changing rounds 2", error);
        }
    }
    static onFormatPickerChange() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing format");
            }
            ScoreSheetFinder.updateFilters({
                payload: {
                    name: "format",
                    value: ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.formatPicker),
                },
            });
        }
        catch (error) {
            console.error("Error while changing format", error);
        }
    }
    static onRaceToChipSelect() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("On race to chip select...");
            }
            const wasSelected = ScoreSheetFinder.filters.GameRowsAreDynamic.value;
            ScoreSheetFinder.updateFilters({
                payload: { name: "GameRowsAreDynamic", value: !wasSelected },
            });
        }
        catch (error) {
            console.error("Error while selecting based on race-to", error);
        }
    }
    static onMyScoreSheetsChipSelect() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("My score sheets chip selected");
            }
            const chip = ScoreSheetFinder.myScoreSheetsChip;
            const value = !ScoreSheetFinderControls.isChipSelected(chip);
            ScoreSheetFinderControls.setChipSelected(chip, value);
            ScoreSheetFinderControls.setSwitchChecked(ScoreSheetFinder.myScoreSheetsSwitch, value);
            ScoreSheetFinder.updateFilters({
                payload: { name: "IsUserTemplate", value: value },
            });
        }
        catch (error) {
            console.error("Error while selecting based on my score sheets", error);
        }
    }
    static onRoundRotationsChipSelect() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Round rotations chip selected");
            }
            // The chip is only visible while the filter is on, so clicking it always
            // means turning it off. The chip itself is refreshed from the state.
            const value = !ScoreSheetFinderControls.isChipSelected(ScoreSheetFinder.roundRotationsChip);
            if (value == false) {
                ScoreSheetFinder.updateRotations({
                    uncheck: true,
                });
            }
        }
        catch (error) {
            console.error("Error while selecting based on round rotations", error);
        }
    }
    static onEventChipSelect() {
        var _a;
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Event chip selected");
            }
            const value = !ScoreSheetFinderControls.isChipSelected(ScoreSheetFinder.eventChip);
            if (value == false) {
                (_a = ScoreSheetFinder.instance.autocomplete) === null || _a === void 0 ? void 0 : _a.ClearValue();
                ScoreSheetFinder.updateFilters({
                    payload: { name: "eventId", value: undefined },
                });
            }
        }
        catch (error) {
            console.error("Error while selecting based on event", error);
        }
    }
    static toggleRoundRotations() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Toggling round rotations");
            }
            ScoreSheetFinder.updateRotations();
        }
        catch (error) {
            console.error("Error while toggling round rotations", error);
        }
    }
    static updateRotations(params) {
        var _a, _b, _c, _d, _e;
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Updating rotations");
            }
            const reset = (_a = params === null || params === void 0 ? void 0 : params.reset) !== null && _a !== void 0 ? _a : false;
            if (reset) {
                ScoreSheetFinderControls.setChipSelected(ScoreSheetFinder.roundRotationsChip, false);
            }
            const uncheck = (_b = params === null || params === void 0 ? void 0 : params.uncheck) !== null && _b !== void 0 ? _b : false;
            const filters = ScoreSheetFinder.filters;
            const games = (_c = filters.NbGames.value) !== null && _c !== void 0 ? _c : 0;
            const rounds = (_d = filters.NbRounds.value) !== null && _d !== void 0 ? _d : 0;
            const players = (_e = filters.NbPlayers.value) !== null && _e !== void 0 ? _e : 0;
            const $drawer = ScoreSheetFinder.roundRotationsDrawer;
            const gamesPerRound = games == 0 || rounds == 0 ? 0 : games / rounds;
            const gamesOrRoundIsNull = games == 0 || rounds == 0;
            const $rounds = $drawer.find(".round");
            if (!$rounds.length) {
                return;
            }
            $rounds.each(function (roundIndex, round) {
                const $round = $(round);
                const roundNumber = parseInt($round.data("round-number"));
                const $roundToggleSwitch = $round.find(`#scoreSheetFinderRotationsToggleSwitchRound-${roundNumber}`);
                if (reset || uncheck) {
                    ScoreSheetFinderControls.setSwitchChecked($roundToggleSwitch, false);
                }
                if (gamesOrRoundIsNull) {
                    $round.removeClass("hiddenforced");
                }
                else if (roundIndex >= rounds) {
                    $round.addClass("hiddenforced");
                }
                else {
                    $round.removeClass("hiddenforced");
                }
                const $games = $round.find(".game");
                if (!$games.length) {
                    return;
                }
                $games.each(function (gameIndex, game) {
                    const $game = $(game);
                    if (reset) {
                        const gameNumber = gameIndex;
                        // Only the away player goes back to its empty value: the home
                        // player keeps the value the server pre-filled it with.
                        ScoreSheetFinderControls.setSelectValue($game.find(`#scoreSheetFinderRotationsAwayPlayer-${roundIndex}-${gameNumber}`), "");
                    }
                    if (gamesOrRoundIsNull) {
                        $game.removeClass("hiddenforced");
                    }
                    else if (gameIndex >= gamesPerRound) {
                        $game.addClass("hiddenforced");
                    }
                    else {
                        $game.removeClass("hiddenforced");
                    }
                });
            });
            const $drawerContent = $drawer.find(".drawer-content__content");
            const $drawerEmptyStateContent = $drawer.find(".drawer-content__empty-state-content");
            if (games == 0 || rounds == 0 || players == 0) {
                $drawerContent.addClass("hiddenforced");
                $drawerEmptyStateContent.removeClass("hiddenforced");
            }
            else {
                $drawerContent.removeClass("hiddenforced");
                $drawerEmptyStateContent.addClass("hiddenforced");
            }
            const oldRotationsStringified = ScoreSheetFinderStore.stringifyRotations(filters.rotations.value);
            const newRotations = ScoreSheetFinder.getRotations();
            const newRotationsStringified = ScoreSheetFinderStore.stringifyRotations(newRotations);
            const newRotationsIsDifferent = oldRotationsStringified != newRotationsStringified;
            filters.rotations.value = newRotations;
            if (newRotationsIsDifferent) {
                ScoreSheetFinder.updateGridDataSource();
            }
        }
        catch (error) {
            console.error("Error while updating rotations", error);
        }
    }
    /** Reloads the results from the server and recomputes the displayed results. */
    static updateGridDataSource() {
        if (ScoreSheetFinder.instance.debug) {
            console.log("Updating grid data source");
        }
        const { store } = ScoreSheetFinder;
        const rotations = ScoreSheetFinderStore.stringifyRotations(store.filters.rotations.value);
        const eventId = store.filters.eventId.value;
        const hasRotations = rotations.trim() != "";
        ScoreSheetFinderControls.setChipSelected(ScoreSheetFinder.roundRotationsChip, hasRotations);
        ScoreSheetFinderControls.setChipSelected(ScoreSheetFinder.eventChip, eventId ? true : false);
        ScoreSheetFinderApi.filter(store.filterRequest, function (results) {
            store.setResults(results);
            ScoreSheetFinder.applyResults();
        });
    }
    static getRotations() {
        let rotations = [];
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Getting rotations");
            }
            const $drawer = ScoreSheetFinder.roundRotationsDrawer;
            const $rounds = $drawer.find(".round");
            if (!$rounds.length) {
                return rotations;
            }
            $rounds.each(function (roundIndex, round) {
                const $round = $(round);
                const roundNumber = parseInt($round.data("round-number"));
                const checked = ScoreSheetFinderControls.isSwitchChecked($round.find(`#scoreSheetFinderRotationsToggleSwitchRound-${roundNumber}`));
                const $games = $round.find(".game");
                const games = [];
                const roundIsHidden = $round.hasClass("hiddenforced");
                if ($games.length) {
                    $games.each(function (gameIndex, game) {
                        const $game = $(game);
                        const gameIsHidden = $game.hasClass("hiddenforced");
                        const gameNumber = gameIndex;
                        const $homePlayer = $game.find(`#scoreSheetFinderRotationsHomePlayer-${roundNumber}-${gameNumber}`);
                        const $awayPlayer = $game.find(`#scoreSheetFinderRotationsAwayPlayer-${roundNumber}-${gameNumber}`);
                        if ($homePlayer.length && $awayPlayer.length) {
                            games.push({
                                home: ScoreSheetFinderControls.getSelectValue($homePlayer),
                                away: ScoreSheetFinderControls.getSelectValue($awayPlayer),
                                hidden: gameIsHidden,
                            });
                        }
                    });
                    rotations.push({
                        round: roundNumber,
                        games: games,
                        checked: roundIsHidden ? false : checked,
                        hidden: roundIsHidden,
                    });
                }
            });
            return rotations;
        }
        catch (error) {
            console.error("Error while getting rotations", error);
            return rotations;
        }
    }
    static onRoundRotationHomePlayerChange(e) {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing home player");
            }
            const $player = $(e.currentTarget);
            const player = ScoreSheetFinderControls.getSelectValue($player);
            if (player != "") {
                const $parentRoundElement = $player.closest(".round");
                if ($parentRoundElement === null || $parentRoundElement === void 0 ? void 0 : $parentRoundElement.length) {
                    const roundNumber = parseInt($parentRoundElement.data("round-number"));
                    const $roundToggleSwitch = $parentRoundElement.find(`#scoreSheetFinderRotationsToggleSwitchRound-${roundNumber}`);
                    if (!ScoreSheetFinderControls.isSwitchChecked($roundToggleSwitch)) {
                        ScoreSheetFinderControls.setSwitchChecked($roundToggleSwitch, true);
                    }
                }
            }
            ScoreSheetFinder.updateRotations();
        }
        catch (error) {
            console.error("Error while changing home player", error);
        }
    }
    static onRoundRotationAwayPlayerChange(e) {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Changing away player");
            }
            const $player = $(e.currentTarget);
            const player = ScoreSheetFinderControls.getSelectValue($player);
            if (player != "") {
                const $parentRoundElement = $player.closest(".round");
                if ($parentRoundElement === null || $parentRoundElement === void 0 ? void 0 : $parentRoundElement.length) {
                    const roundNumber = parseInt($parentRoundElement.data("round-number"));
                    const $roundToggleSwitch = $parentRoundElement.find(`#scoreSheetFinderRotationsToggleSwitchRound-${roundNumber}`);
                    if (!ScoreSheetFinderControls.isSwitchChecked($roundToggleSwitch)) {
                        ScoreSheetFinderControls.setSwitchChecked($roundToggleSwitch, true);
                    }
                }
            }
            ScoreSheetFinder.updateRotations();
        }
        catch (error) {
            console.error("Error while changing home player", error);
        }
    }
    /**
     * Recomputes the results from the state and draws them. Filters are always applied
     * right away: there is no explicit apply step.
     */
    static applyResults() {
        ScoreSheetFinderResults.render();
    }
    /** Turns every chip off, along with the switches that mirror them. */
    static clearAllChips() {
        const compareMultiSelect = ScoreSheetFinder.compareMultiSelect;
        if (compareMultiSelect) {
            compareMultiSelect.clear();
        }
        ScoreSheetFinder.advancedFilterChips.each(function (index, element) {
            var _a;
            const $chip = $(element);
            const field = ((_a = $chip.attr("id")) !== null && _a !== void 0 ? _a : "").split("-")[1];
            if (!field) {
                return;
            }
            ScoreSheetFinderControls.setChipSelected($chip, false);
            ScoreSheetFinderControls.setSwitchChecked($(`#scoreSheetFinderToggleSwitch-${field}`), false);
        });
        ScoreSheetFinderControls.setChipSelected(ScoreSheetFinder.raceToChip, false);
        ScoreSheetFinderControls.setChipSelected(ScoreSheetFinder.myScoreSheetsChip, false);
        ScoreSheetFinderControls.setChipSelected(ScoreSheetFinder.eventChip, false);
        ScoreSheetFinderControls.setSwitchChecked(ScoreSheetFinder.raceToSwitch, false);
        ScoreSheetFinderControls.setSwitchChecked(ScoreSheetFinder.myScoreSheetsSwitch, false);
    }
    /** A switch of the advanced filters drawer applies its filter right away. */
    static toggleAdvancedFilter(e) {
        var _a;
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Toggling advanced filter");
            }
            const $switch = $(e.currentTarget);
            const checked = ScoreSheetFinderControls.isSwitchChecked($switch);
            const field = ((_a = $switch.attr("id")) !== null && _a !== void 0 ? _a : "").split("-")[1];
            if (!field) {
                return;
            }
            ScoreSheetFinderControls.setChipSelected($(`#scoreSheetFinderAdvancedFiltersChip-${field}`), checked);
            const { instance } = ScoreSheetFinder;
            ScoreSheetFinder.updateFilters({
                payload: {
                    name: instance.fieldNameToColumnTitleMap[field],
                    value: checked,
                },
            });
        }
        catch (error) {
            console.error("Error while toggling advanced filter", error);
        }
    }
    static onAdvancedFilterChipSelect(e) {
        var _a;
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Advanced filter chip selected");
            }
            const $chip = $(e.currentTarget);
            const selected = !ScoreSheetFinderControls.isChipSelected($chip);
            const field = ((_a = $chip.attr("id")) !== null && _a !== void 0 ? _a : "").split("-")[1];
            if (!field) {
                return;
            }
            ScoreSheetFinderControls.setChipSelected($chip, selected);
            ScoreSheetFinderControls.setSwitchChecked($(`#scoreSheetFinderToggleSwitch-${field}`), selected);
            const { instance } = ScoreSheetFinder;
            ScoreSheetFinder.updateFilters({
                payload: {
                    name: instance.fieldNameToColumnTitleMap[field],
                    value: selected,
                },
            });
        }
        catch (error) {
            console.error("Error while selecting based on advanced filters", error);
        }
    }
    static setInitialFilters() {
        var _a, _b;
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Setting initial filters");
            }
            const payload = [];
            const initialOpponentType = ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.opponentTypePicker);
            if (initialOpponentType != null && initialOpponentType != "") {
                payload.push({
                    name: "opponentType",
                    value: initialOpponentType,
                });
                switch (initialOpponentType) {
                    case "teams":
                        payload.push({ name: "NbPlayers", value: "" });
                        payload.push({ name: "HasDoubles", value: undefined });
                        break;
                    case "singles":
                        payload.push({ name: "NbPlayers", value: 1 });
                        payload.push({ name: "HasDoubles", value: undefined });
                        break;
                    case "doubles":
                        payload.push({ name: "NbPlayers", value: "" });
                        payload.push({ name: "HasDoubles", value: true });
                        break;
                    default:
                        payload.push({ name: "NbPlayers", value: "" });
                        payload.push({ name: "HasDoubles", value: undefined });
                        break;
                }
            }
            const initialPlayers = ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.playersPicker);
            if (initialPlayers != null && initialPlayers != "") {
                payload.push({
                    name: "NbPlayers",
                    value: initialPlayers,
                });
            }
            const initialGames = ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.gamesPicker);
            if (initialGames != null && initialGames != "") {
                payload.push({
                    name: "NbGames",
                    value: initialGames,
                });
            }
            const initialRounds = ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.roundsPicker);
            if (initialRounds != null && initialRounds != "") {
                payload.push({
                    name: "NbRounds",
                    value: initialRounds,
                });
            }
            const initialBasedOnRaceTo = (_b = (_a = $("#scoreSheetFinderRaceToChipInitialValue")) === null || _a === void 0 ? void 0 : _a.val()) !== null && _b !== void 0 ? _b : "";
            if (ScoreSheetFinder.instance.debug) {
                console.log("Initial based on race to", initialBasedOnRaceTo);
            }
            if (initialBasedOnRaceTo &&
                (initialBasedOnRaceTo == "true" || initialBasedOnRaceTo == true)) {
                payload.push({
                    name: "GameRowsAreDynamic",
                    value: true,
                });
            }
            // Even with nothing to apply, this is what draws the results a first time.
            ScoreSheetFinder.updateFilters({
                payload: payload,
            });
        }
        catch (error) {
            console.error("Error while setting initial filters", error);
        }
    }
    static resetFilters(callback) {
        var _a;
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Resetting filters");
            }
            ScoreSheetFinder.setInitialFilters();
            ScoreSheetFinder.store.resetFilters();
            const format = ScoreSheetFinderControls.getSelectValue(ScoreSheetFinder.formatPicker);
            if (format == "list" || format == "cards") {
                ScoreSheetFinder.filters.format.value = format;
            }
            const compareMultiSelect = ScoreSheetFinder.compareMultiSelect;
            if (compareMultiSelect) {
                compareMultiSelect.clear();
            }
            [
                ScoreSheetFinder.opponentTypePicker,
                ScoreSheetFinder.playersPicker,
                ScoreSheetFinder.playersPicker2,
                ScoreSheetFinder.gamesPicker,
                ScoreSheetFinder.gamesPicker2,
                ScoreSheetFinder.roundsPicker,
                ScoreSheetFinder.roundsPicker2,
            ].forEach(function ($picker) {
                ScoreSheetFinderControls.setSelectValue($picker, "");
            });
            ScoreSheetFinder.updateRotations({ reset: true });
            ScoreSheetFinder.clearAllChips();
            (_a = ScoreSheetFinder.instance.autocomplete) === null || _a === void 0 ? void 0 : _a.ClearValue();
            let $scoreSheetFinderEventId = $("#ScoreSheetFinderEventId");
            if ($scoreSheetFinderEventId === null || $scoreSheetFinderEventId === void 0 ? void 0 : $scoreSheetFinderEventId.length) {
                $scoreSheetFinderEventId.val("");
            }
            ScoreSheetFinder.updateFiltersUI();
            ScoreSheetFinder.applyResults();
            ScoreSheetFinder.updateGridDataSource();
        }
        catch (error) {
            console.error("Error while resetting filters", error);
        }
    }
    static updateFilters(params) {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Updating filters", params);
            }
            const payload = params === null || params === void 0 ? void 0 : params.payload;
            let shouldTriggerRotationsReset = false;
            let shouldTriggerDatasourceUpdate = false;
            if (payload) {
                const items = Array.isArray(payload) ? payload : [payload];
                const itemsThatShouldTriggerRotationsUpdate = [
                    "NbGames",
                    "NbPlayers",
                    "NbRounds",
                ];
                const itemsThatShouldTriggerDatasourceUpdate = ["eventId", "ids"];
                items.forEach((item) => {
                    if (typeof item.name !== "string") {
                        throw new Error("Invalid name, expected string");
                    }
                    if (itemsThatShouldTriggerRotationsUpdate.indexOf(item.name) > -1) {
                        shouldTriggerRotationsReset = true;
                    }
                    if (itemsThatShouldTriggerDatasourceUpdate.indexOf(item.name) > -1) {
                        shouldTriggerDatasourceUpdate = true;
                    }
                    if (item.name === "ids" &&
                        Array.isArray(item.value) &&
                        item.value.length) {
                        // Searching by id drops every other filter, the column filters
                        // included, so that a score sheet looked up by id always shows up.
                        ScoreSheetFinder.store.columnFilters =
                            ScoreSheetFinderState.initialColumnFilters;
                    }
                    ScoreSheetFinder.filters[item.name] = item;
                });
                // Filtering always shows the results from their first page.
                ScoreSheetFinder.store.page = 1;
            }
            ScoreSheetFinder.updateFiltersUI();
            ScoreSheetFinder.applyResults();
            ScoreSheetFinder.updateResultsUI();
            if (shouldTriggerRotationsReset) {
                ScoreSheetFinder.updateRotations({ reset: true });
            }
            if (shouldTriggerDatasourceUpdate) {
                ScoreSheetFinder.updateGridDataSource();
            }
        }
        catch (error) {
            console.error("Error while updating filters", error);
        }
    }
    static updateResultsUI() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Updating results UI");
            }
            ScoreSheetFinderResults.renderFormat();
        }
        catch (error) {
            console.error("Error while updating results UI", error);
        }
    }
    /**
     * Marks a picker as configured or not. The accent given to a configured filter is a
     * style of the finder, carried by the control itself.
     */
    static setPickerActiveState($picker, isActive) {
        ScoreSheetFinderControls.setControlActiveState($picker, isActive);
    }
    static updateFiltersUI() {
        try {
            if (ScoreSheetFinder.instance.debug) {
                console.log("Updating filters UI...");
                console.log("Filters", ScoreSheetFinder.filters);
            }
            const filters = ScoreSheetFinder.filters;
            const opponentType = filters.opponentType.value;
            const hidePlayersAndRotations = opponentType === "singles" || opponentType === "doubles";
            ScoreSheetFinder.playersPicker
                .closest(".scoreSheetFinderInputElement-container")
                .toggleClass("hiddenforced", hidePlayersAndRotations);
            ScoreSheetFinder.rotationsButton
                .closest(".scoreSheetFinderInputElement-container")
                .toggleClass("hiddenforced", hidePlayersAndRotations);
            const hasOpponentType = opponentType != null && opponentType != "";
            if (!hasOpponentType) {
                ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.opponentTypePicker, "");
            }
            ScoreSheetFinder.setPickerActiveState(ScoreSheetFinder.opponentTypePicker, hasOpponentType);
            const players = filters.NbPlayers.value;
            const hasPlayers = players != null && players != "";
            if (!hasPlayers) {
                ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.playersPicker, "");
                ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.playersPicker2, "");
            }
            ScoreSheetFinder.setPickerActiveState(ScoreSheetFinder.playersPicker, hasPlayers);
            ScoreSheetFinder.setPickerActiveState(ScoreSheetFinder.playersPicker2, hasPlayers);
            const games = filters.NbGames.value;
            const hasGames = games != null && games != "";
            if (!hasGames) {
                ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.gamesPicker, "");
                ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.gamesPicker2, "");
            }
            ScoreSheetFinder.setPickerActiveState(ScoreSheetFinder.gamesPicker, hasGames);
            ScoreSheetFinder.setPickerActiveState(ScoreSheetFinder.gamesPicker2, hasGames);
            const rounds = filters.NbRounds.value;
            const hasRounds = rounds != null && rounds != "";
            if (!hasRounds) {
                ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.roundsPicker, "");
                ScoreSheetFinderControls.setSelectValue(ScoreSheetFinder.roundsPicker2, "");
            }
            ScoreSheetFinder.setPickerActiveState(ScoreSheetFinder.roundsPicker, hasRounds);
            ScoreSheetFinder.setPickerActiveState(ScoreSheetFinder.roundsPicker2, hasRounds);
            const basedOnRaceTo = filters.GameRowsAreDynamic.value ? true : false;
            if (ScoreSheetFinder.instance.debug) {
                console.log("Setting race to switch", basedOnRaceTo);
            }
            ScoreSheetFinderControls.setChipSelected(ScoreSheetFinder.raceToChip, basedOnRaceTo);
            ScoreSheetFinderControls.setSwitchChecked(ScoreSheetFinder.raceToSwitch, basedOnRaceTo);
            const isUserTemplate = filters.IsUserTemplate.value ? true : false;
            ScoreSheetFinderControls.setChipSelected(ScoreSheetFinder.myScoreSheetsChip, isUserTemplate);
            ScoreSheetFinderControls.setSwitchChecked(ScoreSheetFinder.myScoreSheetsSwitch, isUserTemplate);
            if (ScoreSheetFinder.instance.debug) {
                console.log("Updated filters UI");
            }
        }
        catch (error) {
            console.error("Error while updating filters UI", error);
        }
    }
}
class ScoreSheet {
    constructor() { }
    static generateThumbnail(params) {
        try {
            const { scoreSheetId, callback, onUploadComplete } = params;
            const popup = new CompuSport.Controls.Popup();
            var data = {
                encounterTypeId: scoreSheetId,
            };
            popup.GetAndShow({
                PopupId: "PreviewScoreSheetPopup",
                Data: data,
                Url: CSParameters.RUrl +
                    "Scores/PreviewPopup/" +
                    CSParameters.SportEventId,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET,
            });
            popup.OnContentLoaded = () => {
                setTimeout(() => {
                    let me = this;
                    const $scoreSheetContainer = popup.Content.find("#ScoreSheetContainerDiv");
                    if (!$scoreSheetContainer.length) {
                        throw new Error("Score sheet container not found");
                    }
                    $scoreSheetContainer.css("background-color", "black");
                    $scoreSheetContainer.css("padding", "8px");
                    let imgElements = $scoreSheetContainer.find('img');
                    let promises = []; // Array to hold all promises for image loading and processing
                    // Create a canvas element
                    var imgCanvas = window.document.createElement('canvas');
                    //Because the images are on another domain, we need to set the crossOrigin attribute to handle CORS and redownload the images
                    imgElements.each((index, imgElement) => {
                        // Create a promise for each image load and process
                        let imgPromise = new Promise((resolve, reject) => {
                            let newImg = new Image();
                            newImg.crossOrigin = "anonymous"; // Set the crossOrigin attribute to handle CORS
                            newImg.onload = () => {
                                try {
                                    // Convert the image to Base64 once it is loaded
                                    imgCanvas.width = imgElement.naturalWidth;
                                    imgCanvas.height = imgElement.naturalHeight;
                                    // Draw the image onto the canvas
                                    var ctx = imgCanvas.getContext('2d');
                                    ctx.drawImage(imgElement, 0, 0);
                                    // Convert the canvas to a base64 string
                                    let base64image = imgCanvas.toDataURL('image/png'); // You can adjust the format
                                    // Create a clone of the current img element without copying its attributes (like 'src').
                                    let clonedImg = imgElement.cloneNode(false);
                                    clonedImg.src = base64image;
                                    // Replace the original img element with the cloned one in the DOM
                                    $(imgElement).replaceWith($(clonedImg));
                                    resolve(null); // Resolve the promise after processing is done
                                }
                                catch (e) {
                                    console.error("Failed to load image with crossOrigin set. " + e);
                                    resolve(null); // Resolve the promise after processing is done
                                }
                            };
                            newImg.onerror = (e) => {
                                console.error("Failed to load image with crossOrigin set. " + e);
                                resolve(null); // Resolve the promise after processing is done
                            };
                            // Set the source last to ensure the load event can be caught
                            newImg.src = imgElement.src;
                        });
                        promises.push(imgPromise); // Add the promise to the array
                    });
                    Promise.all(promises).then(() => {
                        console.log("All images have been loaded and transformed to Base64.");
                        let options = {};
                        options.onclone = (document) => {
                            $(document).find('img').attr('crossOrigin', 'anonymous');
                        };
                        html2canvas($scoreSheetContainer[0], options).then((canvas) => {
                            document.body.appendChild(canvas);
                            canvas.style.display = "none";
                            setTimeout(() => {
                                if (callback) {
                                    const imageDataUrl = canvas.toDataURL("image/png");
                                    popup.Close();
                                    popup.OnClosed = () => {
                                        setTimeout(() => {
                                            callback(imageDataUrl, canvas);
                                        }, 250);
                                    };
                                }
                                else {
                                    const dataImage = canvas
                                        .toDataURL("image/png")
                                        .replace(/^data:image\/(png|jpg);base64,/, "");
                                    const data = {
                                        data: JSON.stringify({
                                            ImageType: "png",
                                            Base64: dataImage,
                                            ScoreSheetId: scoreSheetId,
                                        }),
                                    };
                                    CompuSport.Ajax.Post("/ScoreSheet/UploadScoreSheetThumbnail/", data, function (result) {
                                        popup.Close();
                                        ScoreSheetFinderControls.showToast(`Thumbnail for score sheet ${scoreSheetId} updated successfully!`, "success");
                                    });
                                }
                            }, 250);
                        });
                    });
                }, 250);
            };
        }
        catch (error) {
            console.error("Error while previewing score sheet", error);
        }
    }
}

//# sourceMappingURL=ScoreSheetFinder.js.map
